<div class="wrapper">
    <div class="sidebar" data-color="white" data-active-color="danger" *ngIf="display">
        <sidebar-cmp></sidebar-cmp>
    </div>
    <div [ngClass]="display ? 'main-panel' : 'main-panel-without-sidebar'">
        <navbar-cmp></navbar-cmp>
        <div class="content">
            <div *ngIf="needsOnboarding && onboardingBannerAllowed" class="nf-callout nf-callout--warning" role="status">
                <i class="nc-icon nc-bulb-63 nf-callout-icon"></i>
                <div>La configuration de votre assistant n'est pas terminée. <a routerLink="/onboarding">Terminer la configuration</a></div>
            </div>
            <router-outlet></router-outlet>
        </div>
        <footer-cmp></footer-cmp>
    </div>
</div>
<!--<fixedplugin-cmp></fixedplugin-cmp>-->
